import React from 'react'
import PropTypes from 'prop-types'
import ItemStatusEditor from './ItemStatusEditor'
import { useFindItemInTree, useStatusInfo } from './hooks'
import StatusReportItemTitle from './StatusReportItemTitle'

function StatusReportCommentTitle ({ item, parent, statuses, report }) {
  const theItem = useFindItemInTree(report?.items ?? [], item.statusReportItemId)
  const statusInfo = useStatusInfo(theItem?.status, statuses)

  if (!theItem) return null

  return (
    <>
      <StatusReportItemTitle statusInfo={statusInfo} item={theItem} parent={parent} />
      <ItemStatusEditor
        reportStatus={report?.status}
        statusInfo={statusInfo}
        item={theItem}
        statuses={statuses}
      />
    </>
  )
}

StatusReportCommentTitle.propTypes = {
  item: PropTypes.shape({
    statusReportItemId: PropTypes.number,
    optionLabel: PropTypes.string
  }),
  parent: PropTypes.any,
  statuses: PropTypes.array,
  report: PropTypes.shape({
    items: PropTypes.array,
    status: PropTypes.string
  })
}

export default StatusReportCommentTitle
